var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"event-time"},[_vm._v(_vm._s(_vm._f("date")(_vm.event.event_time?.begin,{ dynamic: true })))]),_c('div',{staticClass:"event-title",on:{"click":_vm.goHome}},[_vm._v(_vm._s(_vm.event.title))]),_c('div',{staticClass:"biz-name"},[_vm._v(_vm._s(_vm.biz.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }